import React from 'react';

export const Reveal = ({ children, stagger = 0, delay = 0.15 }) => {
  return React.cloneElement(children, {
    className: 'reveal',
    style: { '--delay': (stagger + 1) * delay },
  });
};
